import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { ApiResponse } from '../models/api-response.models';
import { PermissionDefinition } from '../models/user.models';
import { unwrapApiResponse } from '../utils/api-response';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  private readonly api = inject(ApiService);
  private permissionsCache$?: Observable<PermissionDefinition[]>;

  list(): Observable<PermissionDefinition[]> {
    if (this.permissionsCache$) return this.permissionsCache$;
    this.permissionsCache$ = this.api
      .get<
        | ApiResponse<PermissionDefinition[]>
        | PermissionDefinition[]
        | { permissions: PermissionDefinition[] }
      >(API_ENDPOINTS.permissions)
      .pipe(
        map((response) => unwrapApiResponse(response)),
        map((response) => (Array.isArray(response) ? response : (response.permissions ?? []))),
        shareReplay({ bufferSize: 1, refCount: false }),
      );
    return this.permissionsCache$;
  }
}
